import { render, staticRenderFns } from "./AddPricesCSV.vue?vue&type=template&id=4304e150&scoped=true&"
import script from "./AddPricesCSV.vue?vue&type=script&lang=js&"
export * from "./AddPricesCSV.vue?vue&type=script&lang=js&"
import style0 from "./AddPricesCSV.vue?vue&type=style&index=0&id=4304e150&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4304e150",
  null
  
)

export default component.exports